import { Alert, Checkbox, Col, Form, Row } from "antd";
import React, { useEffect, useState } from "react";
import NavBar from "../../communs/NavBar";
import Inputs from "../../../biblio/Inputs/Inputs";
import SecondaryButton from "../../../biblio/Buttons/SecondaryButton";
import OtpModal from "../../../components/otpModal/OtpModal";
import ReCAPTCHA from "react-google-recaptcha";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import { getRecaptchaKey, toLogin } from "../../../apis/actions/login.actions";
import ModalComponent from "../../../biblio/Modal/ModalComponent";
import Register from "./Register";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import Loader from "../../../biblio/Loader/Loader";
import dayjs from "dayjs";
import {
  MailOutlined,
  MobileOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
const Login = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [form] = Form.useForm();
  const { loading } = useSelector((state: RootState) => state?.login);
  const [countdown, setCountdown] = useState<number | null>(null);
  const [timeRemaining, setTimeRemaining] = useState<string>("");
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isModalVisibleRegister, setIsModalVisibleRegister] =
    useState<boolean>(false);
  const [IsCaptchaValidated, setIsCaptchaValidated] = useState<boolean>(false);
  const [valid, setIsvalid] = useState<boolean>(false);
  const [mobile, setMobile] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [whatsapp, setWhatsapp] = useState<string>("");
  const [loginType, setLoginType] = useState<"mobile" | "email" | "whatsapp">(
    "mobile",
  );

  const [displayError, setDisplayError] = useState<string>("");
  useEffect(() => {
    if (countdown !== null && countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev && prev > 1) {
            const newTime = prev - 1;
            setTimeRemaining(formatTime(newTime));
            return newTime;
          } else {
            clearInterval(timer);
            return null;
          }
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [countdown]);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(remainingSeconds).padStart(2, "0")}`;
  };
  useEffect(() => {
    if (countdown == null) {
      setDisplayError("");
    }
  }, [countdown]);
  useEffect(() => {
    dispatch(getRecaptchaKey());
  }, [dispatch]);

  const handleCloseOtpModal = () => {
    setIsModalVisible(false);
  };

  const handleCloseModal = () => {
    setIsModalVisibleRegister(false);
  };

  const onFinish = async () => {
    try {
      setDisplayError("");
      setCountdown(null);
      await form.validateFields();

      const values = form.getFieldsValue();
      const payload =
        loginType === "email"
          ? { email: values?.email }
          : loginType === "whatsapp"
            ? { whatsapp: values?.whatsapp }
            : { mobile: values?.mobile };
      setMobile(loginType === "mobile" ? values?.mobile : "");
      setEmail(loginType === "email" ? values?.email : "");
      setWhatsapp(loginType === "whatsapp" ? values?.whatsapp : "");
      const success = (await dispatch(toLogin(payload))) as any;
      const login = success?.payload?.data?.result;

      if (login?.code === 200) {
        setIsModalVisible(true);
      } else {
        const messageTime = login?.message?.match(/\d{2}:\d{2}:\d{2}/)?.[0];
        if (messageTime) {
          const targetTime = dayjs(messageTime, "HH:mm:ss");
          const now = dayjs();
          let diffInSeconds = targetTime.diff(now, "second");
          if (diffInSeconds > 0) {
            setCountdown(diffInSeconds);
            setTimeRemaining(formatTime(diffInSeconds));
          }
        }

        setDisplayError(
          messageTime
            ? login?.message?.slice(0, -15)
            : login?.message
              ? login?.message
              : "... الرجاء الإنتظار قليلا",
        );
      }
    } catch (error) {
      setDisplayError("... الرجاء الإنتظار قليلا");
    }
  };

  //@desc when the user click on the back button of browser it will redirect to the home page
  const [cookies] = useCookies(["apiKey"]);
  const cookiesToken = cookies.apiKey;
  const navigate = useNavigate();
  const [isPageLoading, setIsPageLoading] = useState<boolean>(true);

  useEffect(() => {
    if (cookiesToken) {
      navigate("/");
    } else {
      setIsPageLoading(false);
    }
  }, [cookiesToken, navigate]);

  if (isPageLoading) {
    return <Loader />;
  }

  return (
    <>
      <NavBar variant="homePage" />
      <div className="takaful--add-recipient takaful--login-container">
        <div className="takaful--add-recipient-title-image takaful--login-image-banner">
          <div className="takaful--title-tabs takaful--login-title">
            <span>تسجيل الدخول</span>
            <p>اهلا بك من جديد معنا سجل الدخول للإطلاع على تفاصيل حسابك</p>
          </div>
        </div>

        <Form
          form={form}
          onChange={() => setDisplayError("")}
          layout="vertical"
        >
          {displayError !== "" && (
            <Row gutter={16} className="takaful--login-page">
              <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                <Alert
                  message={
                    <div className="takaful--login-error-message">
                      <span>{displayError}</span>
                      {countdown !== null && <span> {timeRemaining}</span>}
                    </div>
                  }
                  type="error"
                  onClose={() => setDisplayError("")}
                />
              </Col>
            </Row>
          )}
          <Row gutter={16} dir="rtl" className="takaful--login-page">
            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
              <div className="takaful--login-label takaful--login-tabs">
                <span
                  className={loginType === "mobile" ? "active" : ""}
                  onClick={() => {
                    setLoginType("mobile");
                    setDisplayError("");
                  }}
                >
                  <MobileOutlined />
                  الجوال
                </span>
                <span
                  className={loginType === "email" ? "active" : ""}
                  onClick={() => {
                    setLoginType("email");
                    setDisplayError("");
                  }}
                >
                  <MailOutlined />
                  البريد الإلكتروني
                </span>
                <span
                  className={loginType === "whatsapp" ? "active" : ""}
                  onClick={() => {
                    setLoginType("whatsapp");
                    setDisplayError("");
                  }}
                >
                  <WhatsAppOutlined />
                  واتساب
                </span>
              </div>
              {loginType === "mobile" ? (
                <Form.Item
                  key="mobile"
                  name="mobile"
                  rules={[
                    {
                      required: true,
                      message: "رقم الجوال مطلوب",
                    },
                    {
                      len: 10,
                      message: "يجب أن يتكون رقم الهاتف من 10 ارقام",
                    },
                  ]}
                  className="takaful--label-inputs"
                >
                  <Inputs type="tel" placeholder="05XXXXXXXX" maxLength={10} />
                </Form.Item>
              ) : loginType === "whatsapp" ? (
                <Form.Item
                  key="whatsapp"
                  name="whatsapp"
                  rules={[
                    {
                      required: true,
                      message: "رقم الواتساب مطلوب",
                    },
                    {
                      len: 10,
                      message: "يجب أن يتكون رقم الهاتف من 10 ارقام",
                    },
                  ]}
                  className="takaful--label-inputs"
                >
                  <Inputs type="tel" placeholder="05XXXXXXXX" maxLength={10} />
                </Form.Item>
              ) : (
                <Form.Item
                  key="email"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "البريد الإلكتروني مطلوب",
                    },
                    {
                      type: "email",
                      message: "البريد الإلكتروني غير صالح",
                    },
                  ]}
                  className="takaful--label-inputs"
                >
                  <Inputs type="email" placeholder="example@email.com" />
                </Form.Item>
              )}
            </Col>
            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
              <Checkbox
                onChange={(e) => {
                  setIsvalid(e.target.checked);
                }}
              >
                <div className="takaful--login-check-box">
                  <span>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    أوافق على <a>سياسة المساهمة</a>
                  </span>
                </div>
              </Checkbox>
            </Col>
          </Row>
        </Form>

        <Row dir="rtl" style={{ padding: "1.5rem" }}>
          <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
            <div className="takaful--captcha-container">
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_RECAPTCHA_KEY ?? ""}
                onChange={(c: any) =>
                  c ? setIsCaptchaValidated(true) : setIsCaptchaValidated(false)
                }
                hl="ar"
              />
            </div>
          </Col>
          <Col
            xxl={24}
            xl={24}
            lg={24}
            md={24}
            sm={24}
            xs={24}
            className="takaful--login-secondary-button"
          >
            <SecondaryButton
              disabled={!IsCaptchaValidated || !valid || loading}
              title="إرسال رمز التحقق"
              onClick={onFinish}
              loading={loading}
            />
          </Col>
        </Row>

        <Row>
          <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
            <div className="takaful--login-register">
              <span>
                لا تملك حساب مسبقا ؟
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a onClick={() => setIsModalVisibleRegister(true)}>تسجيل</a>
              </span>
            </div>
          </Col>
        </Row>

        <ModalComponent
          title=""
          open={isModalVisibleRegister}
          onClose={handleCloseModal}
          closeOnOutsideClick={true}
          width={450}
          modalStyle={{ top: "20%", minHeight: "20vh", height: "20vh" }}
        >
          <Register />
        </ModalComponent>

        <OtpModal
          open={isModalVisible}
          onClose={handleCloseOtpModal}
          model="login"
          mobile={mobile}
          email={email}
          whatsapp={whatsapp}
        />
      </div>
    </>
  );
};

export default Login;
